export const loginContainer = {
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
}

export const loginWithGoogleButton = {
    mx: 'auto',
    width: '100%',
    mt: 5
}
